import * as yup from "yup";

export const ForgotPasswordSchema = yup.object().shape({
	email: yup
		.string()
		.email("Email must be a valid email")
		.required("Email is required")
});
